// Dependencies
import HeroSlider from 'slider';


class Hero {
  /**
   * Constructor: Hero Constructor.
   */
  constructor(options = {}) {
    // Context
    this._context = options.context || document;

    // Root
    this._root = this._context.querySelector('[type="hero"]');
    
    // Elements
    this._cards = [...this._root.querySelectorAll('.hero-card')];
    this._pages = [...this._root.querySelectorAll('.hero__page')];
    this._prev  = this._root.querySelector('.hero__prev');
    this._next  = this._root.querySelector('.hero__next');

    // Slider Class
    this.Slider = new HeroSlider({
      root   : this._root,
      nodes  : this._cards,
      pages  : this._pages,
      buttons: {
        prev: this._prev,
        next: this._next,
      },
    });
  }
}

export default Hero;


// WEBPACK FOOTER //
// ./src/js/layouts/hero/index.js